<div class='row'>
  <div class='col-12'>
    <app-label label='Wniosek składany do:'>{{ applicationSubmittedTo }}</app-label>
  </div>
  @if (application()?.applicationSubject; as applicationSubject) {
    <div class='col-md-6'>
      <app-label [label]='(application() | applicationSubjectLabel) + ":"'>
        {{ applicationSubject }}
      </app-label>
    </div>
  }
  @if (application()?.transitPeriod; as transitPeriod) {
    <div class="col-md-4">
      <app-label label="Okres przejazdu:">
        {{ transitPeriod || '-' }}
      </app-label>
    </div>
  }
  @if (application()?.exitType; as exitType) {
    <div class="col-md-4">
      <app-label label="Rodzaj zjazdu:">
        {{ exitType || '-' }}
      </app-label>
    </div>
  }
  @if (application()?.exitDirection; as exitDirection) {
    <div class="col-md-4">
      <app-label label="Kierunek zjazdu:">
        {{ exitDirection }}
      </app-label>
    </div>
  }
  @if (application()?.deviceType; as deviceType) {
    <div class="col-md-4">
      <app-label label="Rodzaj urządzenia:">
        {{ deviceType }}
      </app-label>
    </div>
  }
  <div class='col-md-5'>
    <app-label label='Sposób odbioru:'>
      {{ application()?.documentReceiptMethod?.name || '-' }}
    </app-label>
  </div>
  @if (application()?.objectName; as objectName) {
    <div class="col-12">
      <app-label label=" Wskazanie obiektu:">
        {{ objectName }}
      </app-label>
    </div>
  }
  @if (showRoadTrafficImpact()) {
    <div class="col-12">
      <app-label
        label="Czy zajęcie pasa wpłynie na ruch drogowy, ograniczy widoczność na drodze lub wprowadzi zmiany <br> w istniejącej organizacji ruchu pojazdów/pieszych?:">
        {{ application()?.roadTrafficImpact || '-' }}
      </app-label>
    </div>
  }
  @if (application()?.applicationConcernsStreet; as applicationConcernsStreet) {
    <div class="col-md-4">
      <app-label label="Wniosek dotyczy ulicy:">
        {{ applicationConcernsStreet }}
      </app-label>
    </div>
  }
  @if (application()?.ePuapAddress) {
    <div class='col-md-6'>
      <app-label label='Adres skrzynki E-puap:'>
        {{ application()?.ePuapAddress || '-' }}
      </app-label>
    </div>
  }
  @if (application()?.eDeliveryAddress) {
    <div class='col-md-6'>
      <app-label label='Adres skrzynki E-doręczeń:'>
        {{ application()?.eDeliveryAddress || '-' }}
      </app-label>
    </div>
  }
  @if (application()?.notes; as notes) {
    <div class="col-12">
      <app-label [label]="(application() | applicationNotesLabel) + ':'">
        {{ notes }}
      </app-label>
    </div>
  }
  @if (application()?.applicationSubject === 'Przebudowy zjazdu') {
    <div class="col-12">
      <app-label label="Opis przebudowy:">
        {{ application()?.reconstructionDescription || '-' }}
      </app-label>
    </div>
  }
</div>
<div class="row">
  @if (application()?.agreementNumber; as agreementNumber) {
    <div class="col-md-5">
      <app-label label="Nr decyzji/uzgodnienia:">
        {{ agreementNumber }}
      </app-label>
    </div>
  }
  @if (application()?.agreementDate; as agreementDate) {
    <div class="col-md-5">
      <app-label label="Nr decyzji/uzgodnienia:">
        {{ agreementDate | date }}
      </app-label>
    </div>
  }
</div>
@if (showResponsiblePerson()) {
  <br>
  <p class="mb-2">Osoba odpowiedzialna</p>
  <div class="row">
    <div class='col-md-4'>
      <app-label label='Imię:'>
        {{ application()?.responsiblePersonFirstName || '-' }}
      </app-label>
    </div>
    <div class='col-md-4'>
      <app-label label='Nazwisko:'>
        {{ application()?.responsiblePersonLastName || '-' }}
      </app-label>
    </div>
    <div class='col-md-4'>
      <app-label label='Nr telefonu:'>
        {{ application()?.responsiblePersonPhone || '-' }}
      </app-label>
    </div>
    <div class='col-md-4'>
      <app-label label='E-mail:'>
        {{ application()?.responsiblePersonEmail || '-' }}
      </app-label>
    </div>
  </div>
}
@if (showCorrespondenceData()) {
  <br>
  <p class="mb-2">Dane osoby wyznaczonej przez wnioskodawcę do kontaktu</p>
  <div class="row">
    <div class="col-md-4">
      <app-label label="Imię/Imiona:">
        {{ application()?.correspondenceFirstName || '-' }}
      </app-label>
    </div>
    <div class="col-md-4">
      <app-label label="Imię/Imiona:">
        {{ application()?.correspondenceLastName || '-' }}
      </app-label>
    </div>
    <div class="col-md-4">
      <app-label label="Imię/Imiona:">
        {{ application()?.correspondencePhone || '-' }}
      </app-label>
    </div>
  </div>
}
@if (showManager()) {
  <br>
  <p class="mb-2">Kierownik robót</p>
  <div class="row">
    <div class='col-md-4'>
      <app-label label='Imię:'>
        {{ application()?.managerFirstName || '-' }}
      </app-label>
    </div>
    <div class='col-md-4'>
      <app-label label='Nazwisko:'>
        {{ application()?.managerLastName || '-' }}
      </app-label>
    </div>
    <div class='col-md-4'>
      <app-label label='Nr telefonu:'>
        {{ application()?.managerPhone || '-' }}
      </app-label>
    </div>
    <div class='col-md-4'>
      <app-label label='E-mail:'>
        {{ application()?.managerEmail || '-' }}
      </app-label>
    </div>
  </div>
}
